// ---------------------------------------------------------------------------
// DiscoveryToolbar -- Composition Component
// ---------------------------------------------------------------------------
// Renders the DataSource tab group (promoted, primary). View mode controls
// have been moved to the DataTable toolbar. Filter chips and action buttons
// are managed by the parent.
// ---------------------------------------------------------------------------

import React from 'react';
import { DataSourceTabs } from './DataSourceTabs';
import type { DataSourceId } from './types';

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

interface DiscoveryToolbarProps {
  readonly selectedSource: DataSourceId;
  readonly onSourceChange: (source: DataSourceId) => void;
}

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

function DiscoveryToolbar({
  selectedSource,
  onSourceChange,
}: DiscoveryToolbarProps) {
  return (
    <div data-testid="explorer-toolbar" className="flex items-center gap-3">
      <DataSourceTabs selectedSource={selectedSource} onSourceChange={onSourceChange} />
    </div>
  );
}

export { DiscoveryToolbar };
export type { DiscoveryToolbarProps };
